import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'

class Toolbar extends React.Component {

  render() {

    const {
      classes,
      users,
      jobs,
      devices,
      toggle,
      translate,
      toggleFilters
    } = this.props

    return (
      <div>
        {/* Commenting out buttons we don't need at the moment, maybe this functionality will come later or maybe it was never meant to be 
        <Button className={classes.button} color="accent" fab mini onClick={() => users()}>
          <Icon>people</Icon>
        </Button>
        <Button className={classes.button} color="accent" fab mini onClick={() => jobs()}>
          <Icon>settings_input_component</Icon>
        </Button>
        <Button className={classes.button} color="accent" fab mini onClick={() => devices()}>
          <Icon>dock</Icon>
        </Button>
    */}
        <Tooltip title={translate("tooltip_filter")}>
          <Button aria-label="Filter" className={classes.button} color="primary" fab mini onClick={() => toggleFilters()}>
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>
        <Tooltip title={translate("tooltip_view_columns")}  disableTriggerFocus={true}>
          <Button aria-label="View Columns" className={classes.button} color="primary" fab mini onClick={() => toggle()}>
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
